import { useRef } from 'react';

import clamp from 'lodash/clamp';

import { useElementHeight } from '@cast/utils';

import { tableMeasurements } from '../constants';
import { TableSize } from '../types';

export const useGetTableMaxRows = (size: TableSize) => {
  const ref = useRef<HTMLElement | null>(null);
  const rowHeight = tableMeasurements[size].rowHeight;
  const containerHeight = useElementHeight(ref.current);

  return {
    ref,
    maxRows: clamp(Math.floor((containerHeight ?? 0) / rowHeight), 5, 10),
  };
};
